import { useSelector } from "react-redux";
import { exportToYamlFunction } from "../controller/modelYamlExportFunction";
import { getNodeById } from "../controller/nodeSelector";
import * as configUtils from "../controller/utils/configUtils";
import * as pathUtils from "../controller/utils/pathUtils";
import { getIdFunction, getRoot } from "../redux/slice/structureSlice";
import { getEndpointAI, getEndpointTomato } from "../redux/slice/endpointSlice";

function useRequestContainer({ id, type, nodeParent, linkedName = null }) {
  const _idFunction = useSelector(getIdFunction);
  const _endpointAI = useSelector(getEndpointAI);
  const _endpointTomato = useSelector(getEndpointTomato);

  const _nodeRoot = useSelector(getRoot);
  const _nodeParent = nodeParent
    ? nodeParent
    : getNodeById(_nodeRoot, pathUtils.getIdParent(id))?.data;

  const _typeExt =
    type === "constraint" ||
    type === "constraint_expression" ||
    type === "assignment" ||
    type === "assignment_expression" ||
    type === "alias" ||
    type === "alias_expression" ||
    type === "function" ||
    type === "label" ||
    type === "comment";

  const _request = {
    id,
    type,
    linkedName,
    root: _typeExt ? exportToYamlFunction(_nodeRoot, _idFunction) : "",
    parent: _nodeParent,
    mock: configUtils.getMockSuggestions(),
    endpointLocalAI: configUtils.getEndpointLocalAI(),
    endpointAI: _endpointAI,
    endpointTomato: _endpointTomato
  };

  return {
    request: _request,
    nodeRoot: _nodeRoot,
    nodeParent: _nodeParent,
  };
}

export default useRequestContainer;
